module.exports = __webpack_public_path__ + "static/img/logo_1.3234a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_1.png
// module id = ecza
// module chunks = 1